import * as vp from 'vopay';

type BusinessProfileRows = {
  label: vp.BusinessProfileLabel;
  id: vp.BusinessProfileId;
  required: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};


export const buildBusinessProfileRows = (): BusinessProfileRows[] => [
  {
    label: vp.BusinessProfileLabel.CompanyName,
    id: vp.BusinessProfileId.CompanyName,
    required: true,
    preset: 'text',
  },
  {
    label: vp.BusinessProfileLabel.EmailAddress,
    id: vp.BusinessProfileId.EmailAddress,
    required: true,
    preset: 'text',
  },
  {
    label: vp.BusinessProfileLabel.PhoneNumber,
    id: vp.BusinessProfileId.PhoneNumber,
    required: false,
    preset: 'text',
  },
  {
    label: vp.BusinessProfileLabel.Address,
    id: vp.BusinessProfileId.Address,
    required: false,
    preset: 'text',
  },
];

export const buildBusinessProfilePWRows = (): BusinessProfileRows[] => [
  {
    label: vp.BusinessProfileLabel.Password,
    id: vp.BusinessProfileId.Password,
    required: true,
    preset: 'text',
  },
  {
    label: vp.BusinessProfileLabel.ConfirmPassword,
    id: vp.BusinessProfileId.ConfirmPassword,
    required: true,
    preset: 'text',
  }, 
]


